import {type Location, type LocationMap} from './state'
import {type AppState} from '../../types/app-state'
import {type Moment} from 'moment'

export const locationsLoadingSelector = (state: AppState): boolean => state.locations.isFetching

export const locationsSelector = (state: AppState): Location[] => state.locations.locations

export const locationMapSelector = (state: AppState): LocationMap => state.locations.locationMap

export const activeLocationSelector = (state: AppState): Location => state.locations.activeLocation

export const lastUpdatedSelector = (state: AppState): Moment | null => state.locations.lastUpdate

export const hasLocationsSelector = (state: AppState): boolean =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    state.locations.locations?.length > 0 || false
